<h5>QA Completion Dates</h5>
<form [formGroup]="qaForm" id="qaForm">
  <div formArrayName="qaTypesAndLabels">
    @for (process of getQATypeAndLabelRows().controls; track process; let i = $index) {
      <div>
        <div [formGroupName]="i" class="row">
          <!-- #region QA Types -->
          <div class="col-2">
            <label>QA Types <span style="color: red">*</span></label>
            <p-select
              #qaTypeId
              optionValue="id"
              optionLabel="name"
              formControlName="qaTypeID"
              placeholder="Select a QA Type"
              [options]="_srvDropDown.qaType.items"
              (onChange)="enableDisableQATypes(); clearQATypeLabel(i); _srvDropDown.GetQATypeLabels(qaTypeId.value, i)"
              appendTo="body"
              [filter]="true"
            ></p-select>
          </div>
          <!-- #endregion QA Types -->
          <!-- #region QA Type Labels -->
          @if (_srvDropDown.qaTypeLabelList[i]) {
            <div class="col-2">
              <label>QA Type Labels <span style="color: red">*</span></label>
              <p-select
                #selectedQATypeLabel
                optionValue="id"
                optionLabel="name"
                formControlName="qaTypeLabelID"
                placeholder="Select a QA Type label"
                [options]="_srvDropDown.qaTypeLabelList[i].items"
                appendTo="body"
                (onChange)="setupQADates(selectedQATypeLabel, i); getDefectTypes(selectedQATypeLabel, i)"
                appendTo="body"
                [filter]="true"
              ></p-select>
            </div>
          }
          <!-- #endregion QA Type Labels -->
          <!--#region QA Dates-->
          @if (_srvDropDown.splitQATypeLabelValues[i] && _srvDropDown.splitQATypeLabelValues[i].length > 0) {
            <div class="col-2" formArrayName="qaDate">
              @for (calendar of getQADatesByIndex(i).controls; track calendar; let j = $index) {
                <div>
                  <div [formGroupName]="j">
                    <label for="qaDate">{{ _srvDropDown.splitQATypeLabelValues[i][j] }} </label>
                    <p-datepicker
                      class="formCalendar"
                      name="qaDate"
                      formControlName="date"
                      dataType="string"
                      dateFormat="yy-mm-dd"
                      placeholder="Enter Date"
                      appendTo="body"
                      [readonlyInput]="true"
                      [showButtonBar]="true"
                    ></p-datepicker>
                  </div>
                </div>
              }
            </div>
          }
          <!--#endregion QA Dates-->
          <!-- #region Defect Types -->
          @if (showDefectType(_srvDropDown.splitQATypeLabelValues[i], i) && _srvDropDown.splitQATypeLabelValues[i].length > 0) {
            <div class="col-2">
              <label>Defect Types</label>
              <p-select
                optionValue="id"
                optionLabel="name"
                formControlName="defectTypeID"
                placeholder="Select a Defect Type"
                [options]="_srvDropDown.defectType.items"
                appendTo="body"
                [filter]="true"
              />
            </div>
          }
          <!-- #endregion QA Types -->
          <!-- #region Add, Delete Buttons -->
          <div class="col-1 bottom qa-button-container">
            <div class="nde-link-cell">
              <p-button
                class="blue-btn"
                [style.visibility]="getNDETypeURL(i) ? 'visible' : 'hidden'"
                icon="pi pi-external-link"
                pTooltip="Open NDE Link"
                tooltipPosition="left"
                (onClick)="openNDELink(getNDETypeURL(i))"
              />
            </div>
            <div class="nde-add-cell">
              <p-button class="green-btn" icon="pi pi-plus" pTooltip="Add new row" tooltipPosition="right" [disabled]="formDisabled" (onClick)="addQATypeAndLabelRow(); _srvDropDown.addDummy()" />
            </div>
            <div class="nde-delete-cell">
              @if (this.getQATypeAndLabelRows().getRawValue().length > 1) {
                <p-button
                  class="red-btn"
                  icon="pi pi-trash"
                  pTooltip="Delete row"
                  tooltipPosition="right"
                  [disabled]="formDisabled"
                  (onClick)="removeQATypeAndLabelRow(i); _srvDropDown.removeDummy(i); removeHasDefectTypeRow(i)"
                />
              }
            </div>
          </div>
          <!-- #endregion Add, Delete Buttons -->
        </div>
      </div>
    }
  </div>
</form>
<!-- #endregion QA Completion Dates -->
